import(/* webpackMode: "eager", webpackExports: ["ManageSponsorsWrapper"] */ "/app/apps/pickleball/src/modules/players/v2/tabs/sponsors/ManageSponsorsWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/pickleball/src/modules/players/v2/tabs/sponsors/OtherSponsors.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/pickleball/src/modules/players/v2/tabs/sponsors/PrimarySponsor.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/@pickleballinc+react-ui@1.57.0_@floating-ui+react@0.25.4_react-dom@19.2.1_react@19.2.1__27878c287d5b8c3707dc5c80a4e92ee0/node_modules/@pickleballinc/react-ui/index.js");
